import { define, auto, Record } from 'type-r'
import { restfulIO } from 'type-r/endpoints/restful'
import { store } from '../models/store.js'
import View from './view.js'
import tmpl_finTable from './finTable.pug'

@define
export default class TableComponent extends View {
    static endpoint = restfulIO('/json')
    
    @auto({}) declare config: any
    @auto([]) declare header: any
    @auto([]) declare rows: any[]
    
    initialize() {
        this.listenTo(store, "change:currdt", this.refresh);
    }

    parse(data?:any) {
        data = super.parse(data);
        if (data?.extras) {
            this.trigger("extras", data.extras);
            delete data.extras;
        }
        if (data?.data) {
            data = data.data;
        }
        return data;
    }
    
    render(): void {
        let config = this.config
        let header = this.header
        let rows = this.rows
        let html = tmpl_finTable({ name: this.id, config, header, rows });

        $(this.el).html(html);
    }

    async refresh() {
        await this.fetch()
        this.render()
    }

    fetch(opts?: any) {
        return super.fetch({params: {fj: store.token, type: this.id, ...opts?.params}})
    }
}

